const ptBr = {
    translations: {
        navbar: {
            detail_one: "Principal",
            detail_two: "Sobre",
            detail_three: "Habilidades",
            detail_four: "Serviços",
            detail_five: "Certificados",
            detail_six: "Contato",
            detail_seven: "Qualificações",
        },

        home: {
            title: "Desenvolvedora Frontend",
            text: "Olá! Sou a Katianne Araújo, Desenvolvedora Front-End, apaixonada por criar interfaces limpas, responsivas e fáceis de usar. Atuo com desenvolvimento web, trabalhando com landing pages e aplicações web como freelancer e em equipes remotas. Atualmente sou colaboradora na Ovonne como Desenvolvedora Front-End e Líder Técnica, contribuindo com a organização dos projetos, orientação do time e aplicação de boas práticas. Sou formada em Análise e Desenvolvimento de Sistemas e tenho formação técnica em Informática. Sou proativa, estou em constante aprendizado e gosto de desafios que me permitam evoluir e entregar soluções digitais de qualidade. 🚀",
            button: "Fale comigo!",
            scrollDown: "Rolar para baixo",
        },

        about: {
            title: "Sobre mim",
            subtitle: "Introdução",
            text: "Sou formada em Análise e Desenvolvimento de Sistemas e possuo curso técnico em Informática, o que me proporcionou uma base sólida em tecnologia desde cedo. Ao longo da minha trajetória, já trabalhei com projetos em diversas áreas, como saúde, advocacia, educação, vendas e serviços, sempre buscando entregar soluções responsivas, acessíveis e bem estruturadas. Tecnologias que utilizo:Frontend: HTML5, CSS3, JavaScript, TypeScript, React.js, Next.js, Vue.js Backend & Integrações: Node.js, Prisma, Firebase, APIs REST Ferramentas: Git, GitHub, GitLab, Figma, Stripe, Docker Outros: Microserviços, Microfrontend, Versionamento de Código Meu diferencial está na proatividade e vontade constante de aprender. Não me limito ao que já sei: quando surge um desafio novo, busco aprender, aplicar e evoluir para entregar sempre o melhor resultado possível. Gosto de trabalhar em equipe, tenho boa comunicação, senso de responsabilidade e organização de tarefas e prazos. Acredito que a tecnologia, quando bem aplicada, pode criar experiências incríveis e soluções que realmente fazem a diferença. Se quiser conhecer meus projetos ou colaborar em algo novo, será um prazer conversar!",
        },

        info: {
            title_one: "Experiências",
            subtitle_one: "4 anos",
            title_two: "Concluído",
            subtitle_two: "50+ projetos",
            title_three: "Aprendizados",
            subtitle_three: "4+ Tecnologias",
        },

        skills: {
            title: "Habilidades",
            subtitle: "Meu Nivel Técnico",
            front_title: "Desenvolvedor Frontend",
            back_title: "Desenvolvedor Backend",
            basic: "Básico",
            inter: "Intermediário ",
            advan: "Avançado",
        },

        services: {
            title: "Serviços",
            subtitle: "O que eu ofereço",
            services_title_one: "Desenvolvimento Front-End",
            services_title_two: "Sistemas Web & Integrações",
            services_title_three: "Liderança Técnica & Otimização",
            button: "Veja Mais",
            modal_one: "Criação de interfaces web focadas em performance, acessibilidade e experiência do usuário, seguindo boas práticas e layouts do Figma.",
            p_one: "Desenvolvimento de Interface do Usuário",
            p_two: "Desenvolvimento de Paginas Webs",
            p_three: "Desenvolvimento de Design",
            p_four: "Integração com APIS",
            p_five: "Tecnologias: HTML, CSS, JavaScript, TypeScript, React, Next.js, Vue.js",
            modal_two: "Desenvolvimento e integração de sistemas web com APIs, autenticação, pagamentos e banco de dados, garantindo estabilidade e segurança.",
            p_two_one: "Integração com APIs REST",
            p_two_two: "Autenticação e gestão de usuários",
            p_two_three: "Pagamentos (Stripe)",
            p_two_four: "Integração com Firebase e Prisma",
            p_two_five: "Tecnologias: Node.js, Prisma, Firebase, REST APIs, Stripe",
            modal_three: "Apoio técnico para equipes e projetos, focando em boas práticas, organização de código e melhorias contínuas.",
            p_three_one: "Organização de tarefas e fluxo de desenvolvimento",
            p_three_two: "Revisão e padronização de código",
            p_three_three: "Otimização de performance e acessibilidade",
            p_three_four: "Mentoria e suporte técnico ao time",
            p_three_five: "Diferenciais: Boas práticas, acessibilidade, versionamento com Git, trabalho colaborativo",
        },

        qualification: {
            title: "Qualificações",
            subtitle: "Minha Jornada Pessoal",
            qualification_title_one: "Educação",
            qualification_title_two: "Experiências",
            qualification_subtitle_one: "Tecnico em Informática",
            qualification_subtitle_two: "Escola Profissionalizante",
            qualification_subtitle_three: "Analise e Desenvolvimento de Sistemas",
            qualification_subtitle_four: "Estagiário de TI",
            qualification_subtitle_five: "Aluno",
            qualification_subtitle_six: "Desenvolvedor Frontend",
            qualification_subtitle_seven: "Desenvolvedor Frontend / Líder tecnico",
            data_one: "Ago",
            data_two: "Maio",
            data_three: "Dez",
            data_four: "Jul",
            data_seven: "Fev"
        },

        Certificates: {
            title: "Certificados",
            subtitle: "Qualificações adquiridas",
            time_one: "Horas",
            title_one: "Aplicações avançadas com Angular",
            title_two: "Acelerador de Carreira com Power BI",
            title_three: "Conceitos e melhores práticas com bancos de dados PostgreSQLs",
            title_five: "Desenvolvimento avançado com JavaScript ES6",
            title_six: "Desenvolvimento avançado em Java",
            title_seven: "Estrutura de dados em Java",
            title_eight: "Excel Avançado",
            title_nine: "Hiring Coders #3 na Trilha de Formação em Full Stack",
            title_ten: "Hiring Coders #3 na Trilha de formação em VTEX IO, AWS, DevOps e Digital E-commerce",
            title_eleven: "Hiring Coders #3 na Trilha de formação em VTEX IO",
            title_thirteen: "Implementando Collection e Streams com Java",
            title_fourteen: "Introdução a criação de websites com HTML5 e CSS3",
            title_fiveteen: "Introdução ao Angular 8",
            title_seventeen: "Maratona do Zero ao Código- IV Edição",
            title_eighteen: "Maratona Invertida",
            title_twenty: "Semana Spring React",
            title_twentythree: "Técnicas avançadas em Angular 8",
        },

        Contact: {
            title: "Entre em Contato",
            subtitle: "Meus Contatos",
            title_one: "Fale Comigo!",
            title_two: "Deixe sua mensagem",
            button_link: "Escreva me",
            name: "Nome",
            input_name: "Inserir seu nome",
            input_email: "Inserir seu email",
            textarea: "Mensagem",
            button: "Enviar Mensagem"
        },

        footer: {
            text: "Todos os Direitos Reservados"
        }
    }
}

export default ptBr;